import { Check } from 'lucide-react'

export function Plans() {
  const plans = [
    { name: 'Basic', price: '1 hour' },
    { name: 'Advanced', price: 'Unlimited' },
    { name: 'Professional', price: 'Unlimited' },
    { name: 'Enterprise', price: 'Custom' }
  ]

  const features = [
    'Source Cloud',
    'Interactive Tags',
    'Multi-user Users',
    'Remote Configuration',
    'Dashboard',
    'Email Support',
    'Alarms',
    'Mobile Apps',
    'Quick Start',
    'API',
    'Data Portal',
    'Admin Data',
    'Public Portal',
    'Team Manage',
    'Data Storage'
  ]

  return (
    <section id="plans" className="py-24 bg-white">
      <div className="max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-[140px]">
        <h2 className="text-3xl font-bold text-[#4D4D4D] mb-10 pb-4 border-b border-gray-200">Plans</h2>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse min-w-max">
            <thead>
              <tr className="bg-gray-50 border-b border-gray-200">
                <th className="text-left p-6 font-semibold text-[#4D4D4D] text-sm w-1/4">
                  Features
                </th>
                {plans.map((plan, idx) => (
                  <th key={idx} className="text-center p-6 font-bold text-[#4D4D4D] border-l border-gray-200">
                    <div className="text-lg mb-1">{plan.name}</div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {features.map((feature, idx) => (
                <tr key={idx} className="border-b border-gray-200 hover:bg-gray-50 transition">
                  <td className="p-6 text-sm text-gray-700">{feature}</td>
                  {plans.map((_, pidx) => (
                    <td key={pidx} className="text-center p-6 border-l border-gray-200">
                      <Check className="w-5 h-5 text-blue-600 mx-auto" />
                    </td>
                  ))}
                </tr>
              ))}
              <tr className="border-t-2 border-gray-300 bg-gray-50">
                <td className="p-6 text-sm font-semibold text-gray-900">Storage</td>
                <td className="text-center p-6 text-sm text-gray-700 border-l border-gray-200">1 hour</td>
                <td className="text-center p-6 text-sm text-gray-700 border-l border-gray-200">Unlimited</td>
                <td className="text-center p-6 text-sm text-gray-700 border-l border-gray-200">Unlimited</td>
                <td className="text-center p-6 text-sm text-gray-700 border-l border-gray-200">Unlimited</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  )
}
